export default function MetricCard({ label, value, detail, status = "neutral" }) {
  return (
    <article className={`metric-card is-${status}`}>
      <span>{label}</span>
      <strong>{value}</strong>
      {detail ? <small>{detail}</small> : null}
    </article>
  );
}
